import type { ResourceSourceType } from 'generated/types';

export interface GetRecordSourceForSubmitParams {
  isCurator?: boolean;
  isCreating?: boolean;
  initialRecordSource?: ResourceSourceType;
  currentRecordSource?: ResourceSourceType;
}

/**
 * Returns the record source to persist on submit, or undefined when the source
 * should not be written (non-curator, unchanged edit, or blank source).
 */
export function getRecordSourceForSubmit({
  isCurator,
  isCreating,
  initialRecordSource,
  currentRecordSource,
}: GetRecordSourceForSubmitParams): ResourceSourceType | undefined {
  return isCurator &&
    currentRecordSource &&
    (isCreating || initialRecordSource !== currentRecordSource)
    ? currentRecordSource
    : undefined;
}
